var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from "@material-ui/icons/Close";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, makeStyles, } from "@material-ui/core";
var useStyles = makeStyles(function (theme) { return ({
    closeButton: {
        position: "absolute",
        top: theme.spacing(1),
        right: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}); });
export var Modal = function (_a) {
    var title = _a.title, isOpen = _a.isOpen, onDismiss = _a.onDismiss, maxWidth = _a.maxWidth, fullWidth = _a.fullWidth, scroll = _a.scroll, p = _a.p, children = _a.children;
    var classes = useStyles();
    return (_jsxs(Dialog, __assign({ open: !!isOpen, onClose: onDismiss, maxWidth: maxWidth || "md", fullWidth: !!fullWidth, scroll: scroll || undefined }, { children: [_jsxs(DialogTitle, { children: [title, _jsx(IconButton, __assign({ "aria-label": "close", className: classes.closeButton, onClick: onDismiss }, { children: _jsx(CloseIcon, {}, void 0) }), void 0)] }, void 0), _jsx(DialogContent, __assign({ dividers: true }, { children: _jsx(Box, __assign({ p: p !== null && p !== void 0 ? p : 3 }, { children: children }), void 0) }), void 0)] }), void 0));
};
